import * as yup from "yup"

const validationSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  cookieString: yup.string().required("Cookie string is required"),
})

export default validationSchema
